import { Component, OnInit, NgModule, Input, NgZone } from '@angular/core';
import { SideNavigationMenuModule, HeaderModule, FooterModule } from '../../shared/components';
import { ScreenService } from '../../shared/services';
import { DxDrawerModule } from 'devextreme-angular/ui/drawer';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';
import { CommonModule } from '@angular/common';
import * as _ from 'lodash';
import { navigation } from '../../app-navigation';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { APIConfing } from 'src/app/shared/services/apiconfing.service';
import { Title } from '@angular/platform-browser';
import { SignInModule } from 'src/app/core/component/sign-in/sign-in.module';
// import { Message, NotificationServiceService } from 'src/app/shared/services/notification.service';
import { DxDataGridModule } from 'devextreme-angular';
import { CommonService } from 'src/app/shared/services/common.service';
import { EncryptDecryptService } from 'src/app/shared/services/encrypt-decrypt.service';

@Component({
  selector: 'app-side-nav-outer-toolbar',
  templateUrl: './side-nav-outer-toolbar.component.html',
  styleUrls: ['./side-nav-outer-toolbar.component.scss'],
  standalone: false
})
export class SideNavOuterToolbarComponent implements OnInit {
  menuItems: any;
  selectedRoute = '';

  menuOpened: boolean = true;
  temporaryMenuOpened = false;

  @Input()
  title: string;
  session: any;

  menuMode = 'shrink';
  menuRevealMode = 'expand';
  minMenuSize = 0;
  shaderEnabled = false;
  isWhiteLabled: any;
  showSideBar = true;
  signInVisible = false;
  footerLink: any;
  footerText: any;
  footerImg: any;
  redirectToBillAuth = false;
  redirectToPublicContentAuth = false;

  switchEnabled = false;
  appVersion: any;

  constructor(private screen: ScreenService, private router: Router,
    private _ngZone: NgZone, private enc: EncryptDecryptService,
    private cookies: CookieService, private pageTitle: Title, public common: CommonService) {
    if (APIConfing.data.isWhiteLabled != 'No')
      pageTitle.setTitle(APIConfing.data.isWhiteLabled);
    this.isWhiteLabled = APIConfing.data.isWhiteLabled;
    this.footerLink = APIConfing.data.footerConfig.footerLink;
    this.footerText = APIConfing.data.footerConfig.footerText;
    this.footerImg = APIConfing.data.footerConfig.footerImg;
    this.switchEnabled = APIConfing.data.switchEnabled;
    this.appVersion = APIConfing.data.appVersion || '1.1.2';
    this.redirectToBillAuth = sessionStorage.getItem(this.enc.encryptUsingAES256('redirectToBill')) == 'true' ? true : false;;
    // const getToken = JSON.parse(atob(sessionStorage.getItem(this.enc.encryptUsingAES256('esstoken'))));
    const getToken = JSON.parse(enc.decryptUsingAES256(sessionStorage.getItem(this.enc.encryptUsingAES256('esstoken'))));
    this.session = JSON.parse(enc.decryptUsingAES256(sessionStorage.getItem(this.enc.encryptUsingAES256('esstoken'))));
    // console.log(this.session);
    //  CryptoJS.AES.decrypt(JSON.stringify(dataRESP.dataObject)).toString()
    // tslint:disable-next-line: only-arrow-functions
    // this.notification.userId = getToken[0].consultantID;
    // if (this.notification.userId) {
    //   this.notification.createConnection();
    //   this.notification.registerOnServerEvents();
    //   this.notification.startConnection();
    //   this.subscribeToEvents();
    // }
    this.menuItems = _.filter(navigation, function (obj) {
      if (getToken[0].isESS === 'ESS') {
        // if (obj.path === '/Timesheet-Submission') {
        //   obj.visible = obj.path === '/Timesheet-Submission' && getToken[0].disableESSTimeSheetSubmit === 0 ? true : false;
        // }
        if (obj.path === '/My-Details') {
          obj.visible = obj.path === '/My-Details' ? true : false;
        }
        if (obj.path === '/HR-Activities') {
          obj.visible = obj.path === '/HR-Activities' &&
            (getToken[0].cssOptions.allowToResign === 1 || getToken[0].cssOptions.allowLoanApply === 1 || getToken[0].cssOptions.allowHRQuery === 1
              || getToken[0].cssOptions.policyDocCnt > 0 || getToken[0].cssOptions.pFtrustDetailsCnt > 0 || getToken[0].cssOptions.genDeclarationCnt > 0 || getToken[0].cssOptions.insuranceCnt > 0) ? true : false;
        }
        if (obj.path === '/Requirements') {
          obj.visible = obj.path === '/Requirements' && getToken[0].cssOptions.requirementListAccess === 1 ? true : false;
        }
        // if (obj.path === '/Timesheet-Submission1') {
        //   obj.visible = obj.path === '/Timesheet-Submission1' && getToken[0].allowTimeSheetApply === 1 ? true : false;
        // }
        if (obj.path === '/Team-Members') {
          obj.visible = obj.path === '/Team-Members' && (getToken[0].reportingEmployeeCnt > 0 && getToken[0].allowRMtoUpdateTeamAttendanceWithSelfie !== 1) ? true : false;
        }
        if (obj.path === '/Team-Attendance-Summary') {
          obj.visible = obj.path === '/Team-Attendance-Summary' && getToken[0].reportingEmployeeCnt > 0 ? true : false;
        }
        if (obj.path === '/Team-Members-Attendance') {
          obj.visible = obj.path === '/Team-Members-Attendance' && getToken[0].reportingEmployeeCnt > 0 ? true : false;
        }
        // if (obj.path === '/Attendance-Tracker') {
        //   obj.visible = obj.path === '/Attendance-Tracker' && getToken[0].reportingEmployeeCnt > 0 ? true : false;
        // }
        if (obj.path === '/Reimbursement-Claim') {
          obj.visible = obj.path === '/Reimbursement-Claim' && getToken[0].cssOptions.allowReimbApply === 1 ? true : false;
        }
        if (obj.path === '/Apply-Leave') {
          obj.visible = (obj.path === '/Apply-Leave') && (getToken[0].enableLeaveApplicability ? true : false);
        }
        if (obj.path === '/Loan-Request') {
          obj.visible = obj.path === '/Loan-Request' && getToken[0].cssOptions.allowLoanApply === 1 ? true : false;
        }
        if (obj.path === '/My-Approvals') {
          obj.visible = obj.path === '/My-Approvals' && getToken[0].reportingEmployeeCnt > 0 ? true : false;
        }
        if (obj.path === '/My-Document') {
          obj.visible = obj.path === '/My-Document' && getToken[0].myDocumentCnt > 0 ? true : false;
        }
        if (obj.path === '/PF-Trust') {
          obj.visible = obj.path === '/PF-Trust' && getToken[0].pFtrustDetailsCnt > 0 ? true : false;
        }
        if (obj.path === '/Offer-Acceptance') {
          obj.visible = obj.path === '/Offer-Acceptance' && getToken[0].isOfferReleased === 1 ? true : false;
        }
        if (obj.path === '/Assets-Details') {
          obj.visible = obj.path === '/Assets-Details' && getToken[0].cssOptions.enableAssets === 1 ? true : false;
        }
        if (obj.path === '/consultant-documentation') {
          obj.visible = obj.path === '/consultant-documentation' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/Personal-Info') {
          obj.visible = obj.path === '/Personal-Info' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/skill-details') {
          obj.visible = obj.path === '/skill-details' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/Social') {
          obj.visible = obj.path === '/Social' && getToken[0].cssOptions && getToken[0].cssOptions.enableSocialFeed === 1 ? true : false;
        }
        if (obj.path === '/Employee-Directory') {
          obj.visible = obj.path === '/Employee-Directory' && getToken[0].cssOptions && getToken[0].cssOptions.enableEmpDirectory === 1 ? true : false;
        }
        if (obj.path === '/Org-Chart') {
          obj.visible = obj.path === '/Org-Chart' && getToken[0].cssOptions && getToken[0].cssOptions.enableEmpDirectory === 1 ? true : false;
        }
        if (obj.path === '/My-Queries') {
          obj.visible = obj.path === '/My-Queries' && getToken[0].cssOptions && getToken[0].cssOptions.allowHRQuery === 1 ? true : false;
        }
        if (obj.path === '/FBP-Perk') {
          obj.visible = obj.path === '/FBP-Perk' && getToken[0].allowEmpToUpdateFBAmt > 0 ? true : false;
        }
        if (obj.path === '/References') {
          obj.visible = false;
        }
        if (obj.path === '/Address-Info') {
          obj.visible = false;
        }
        if (obj.path === '/Family-info') {
          obj.visible = false;
        }
        if (obj.path === '/Education-info') {
          obj.visible = false;
        }
        if (obj.path === '/Employement-info') {
          obj.visible = false;
        }
        if (obj.path === '/Bank-Details') {
          obj.visible = false;
        }
        if (obj.path === '/Investment-Declaration') {
          obj.visible = obj.path === '/Investment-Declaration' && getToken[0].cssOptions.allowInvestmentDeclar === 1 ? true : false;
        }
        if (obj.path === '/home') {
          obj.visible = obj.path === '/home' && getToken[0].onboardStatus === 1 || getToken[0].isOnboardingInitiated === 1 ? true : false;
        }
        if (obj.path === '/Approved-Timesheet') {
          obj.visible = obj.path === '/Approved-Timesheet' && getToken[0].approvedTimeSheetCnt === 1 ? true : false;
        }
        if (obj.path === '/Pay-Details') {
          obj.visible = obj.path === '/Pay-Details' && getToken[0].payrolProcessCnt === 1 ? true : false;
        }
        if (obj.path === '/Insurance-Details') {
          obj.visible = obj.path === '/Insurance-Details' && getToken[0].insuranceCnt > 0 ? true : false;
        }
        if (obj.path === '/Salary-details') {
          obj.visible = obj.path === '/Salary-details' && getToken[0].cssOptions.hideSalDetails === 1 ? true : false;
        }
        if (obj.path === '/Holiday-Work') {
          obj.visible = obj.path === '/Holiday-Work' && getToken[0].allowCompOffRequest === 1 ? true : false;
        }
        if (obj.path === '/Attendance-Correction') {
          obj.visible = obj.path === '/Attendance-Correction' && (getToken[0].cssOptions.allowAttendRegularize === 1) && ((getToken[0].allowBiometricAttCorrection) || (getToken[0].cssOptions.attendancePunch > 0 && getToken[0].cssOptions.attendancePunch < 4)) ? true : false;
        }
        if (obj.path === '/Miss-Punch') {
          obj.visible = obj.path === '/Miss-Punch' && (getToken[0].cssOptions.attendancePunch > 0 && getToken[0].cssOptions.attendancePunch < 4) ? true : false;
        }
        if (obj.path === '/Track-me') {
          obj.visible = obj.path === '/Track-me' && getToken[0].enableTrackMe === 1 ? true : false;
        }
        if (obj.path === '/Bill-Authorization') {
          obj.visible = obj.path === '/Bill-Authorization' && getToken[0].cssOptions.enableBillAuthorization === 1 ? true : false;
        }
        if (obj.path === '/General-Declaration') {
          obj.visible = obj.path === '/General-Declaration' && getToken[0].genDeclarationCnt > 0 ? true : false;
        }
        if (obj.path === '/Policy-Documents') {
          obj.visible = obj.path === '/Policy-Documents' && getToken[0].cssOptions.policyDocCnt > 0 ? true : false;
        }
        if (obj.path === '/Resignation') {
          obj.visible = obj.path === '/Resignation' && getToken[0].cssOptions.allowToResign === 1 ? true : false;
        }
        if (obj.path === '/FAQ-Template') {
          obj.visible = obj.path === '/FAQ-Template' && getToken[0].faqTemplateID > 0 ? true : false;
        }
        if (obj.path === '/PMS-Details') {
          obj.visible = obj.path === '/PMS-Details' && getToken[0].pmsAssessmentCount > 0 ? true : false;
        }
        if (obj.path === '/Inventory') {
          obj.visible = obj.path === '/Inventory' && getToken[0].enableInventory > 0 ? true : false;
        }
        // if (obj.path === '/Bank-Change-Request') {
        //   obj.visible = obj.path === '/Bank-Change-Request' && getToken[0].cssOptions.requestForBankAccChange === 1 ? true : false;
        // }
        return obj.type === getToken[0].isESS;
      } else {
        if (obj.path === '/Offer-Acceptance') {
          obj.visible = obj.path === '/Offer-Acceptance' && getToken[0].isOfferReleased === 1 ? true : false;
        }
        if (obj.path === '/home/Assets-Details') {
          obj.visible = obj.path === '/home/Assets-Details' && getToken[0].cssOptions.enableAssets === 1 ? true : false;
        }
        if (obj.path === '/home/consultant-documentation') {
          obj.visible = obj.path === '/home/consultant-documentation' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/home/Personal-Info') {
          obj.visible = obj.path === '/home/Personal-Info' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/home/Profile-Photo') {
          obj.visible = obj.path === '/home/Profile-Photo' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/home/skill-details') {
          obj.visible = obj.path === '/home/skill-details' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/home/Address-Info') {
          obj.visible = obj.path === '/home/Address-Info' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/home/Family-info') {
          obj.visible = obj.path === '/home/Family-info' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/home/Education-info') {
          obj.visible = obj.path === '/home/Education-info' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/home/Employement-info') {
          obj.visible = obj.path === '/home/Employement-info' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/home/Bank-Details') {
          obj.visible = obj.path === '/home/Bank-Details' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/home/References') {
          obj.visible = obj.path === '/home/References' && getToken[0].onboardStatus > 0 ? true : false;
        }
        if (obj.path === '/home/Onboarding-Declaration') {
          obj.visible = obj.path === '/home/Onboarding-Declaration' && getToken[0].onboardStatus > 0 && getToken[0].onboardDeclarationCnt > 0 ? true : false;
        }

        return obj.type === getToken[0].isESS;
      }
    });

    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.selectedRoute = val.urlAfterRedirects.split('?')[0];
        if (this.router.url.includes('/Offer-Acceptance')) {
          this.showSideBar = false;
          this.menuOpened = false;
          this.temporaryMenuOpened = false;
          this.screen.changed.subscribe(() => this.updateDrawer());
          this.updateDrawer();
        }
        else {
          if (sessionStorage.getItem(this.enc.encryptUsingAES256('redirectToBill')) == 'true') {
            this.showSideBar = false;
          } else if (this.router.url.includes('/Public/Onboarding')) {
            this.showSideBar = false;
            this.redirectToPublicContentAuth = true;
          } else {
            this.showSideBar = true;
            this.redirectToPublicContentAuth = false;
          }
          if (this.cookies.check('cssMenu')) {
            this.menuOpened = JSON.parse(this.cookies.get('cssMenu'));
          } else {
            this.menuOpened = this.screen.sizes['screen-large'];
            this.cookies.set('cssMenu', JSON.stringify(this.menuOpened));
          }
          this.screen.changed.subscribe(() => this.updateDrawer());
          this.updateDrawer();
        }
        if (this.router.url === '/sign-in') {
          this.signInVisible = true;
        }
        else {
          this.signInVisible = false;
        }
      }
    });
  }
  ngOnInit() {
    if (this.router.url.includes('/Offer-Acceptance')) {
      this.showSideBar = false;
      this.menuOpened = false;
      this.temporaryMenuOpened = false;
      this.screen.changed.subscribe(() => this.updateDrawer());
      this.updateDrawer();
    }
    else {
      if (sessionStorage.getItem(this.enc.encryptUsingAES256('redirectToBill')) == 'true') {
        this.showSideBar = false;
      } else if (this.router.url.includes('/Public/Onboarding')) {
        this.showSideBar = false;
        this.redirectToPublicContentAuth = true;
      } else {
        this.showSideBar = true;
        this.redirectToPublicContentAuth = false;
      }
      if (this.cookies.check('cssMenu')) {
        this.menuOpened = JSON.parse(this.cookies.get('cssMenu'));
      } else {
        this.menuOpened = this.screen.sizes['screen-large'];
        this.cookies.set('cssMenu', JSON.stringify(this.menuOpened));
      }
      this.screen.changed.subscribe(() => this.updateDrawer());
      this.updateDrawer();
    }
    if (this.router.url === '/sign-in') {
      this.signInVisible = true;
    }
    else {
      this.signInVisible = false;
    }

    this.common.sharedVariable$.subscribe(value => {
      for (let index = 0; index < this.menuItems.length; index++) {
        const element = this.menuItems[index];
        if (element.path === '/home/consultant-documentation') {
          this.menuItems[index].visible = this.session[0].onboardStatus > 0 && value ? true : false;
        }
      }
    });
    this.common.sharedObj$.subscribe(obj => {
      for (let index = 0; index < this.menuItems.length; index++) {
        const element = this.menuItems[index];
        if (element.path === '/home/consultant-documentation') {
          this.menuItems[index].visible = obj && obj.mandatoryforDocuments != 2;
        }
        if (element.path === '/home/Personal-Info') {
          this.menuItems[index].visible = obj && obj.mandatoryforPersonalDetails != 2;
        }
        if (element.path === '/home/Profile-Photo') {
          this.menuItems[index].visible = obj && obj.mandatoryforPhoto != 2;
        }
        if (element.path === '/home/skill-details') {
          this.menuItems[index].visible = obj && obj.mandatoryforSkills != 2;
        }
        if (element.path === '/home/Address-Info') {
          this.menuItems[index].visible = obj && obj.mandatoryforAddress != 2;
        }
        if (element.path === '/home/Family-info') {
          this.menuItems[index].visible = obj && obj.mandatoryforFamily != 2;
        }
        if (element.path === '/home/Education-info') {
          this.menuItems[index].visible = obj && obj.mandatoryforEducation != 2;
        }
        if (element.path === '/home/Employement-info') {
          this.menuItems[index].visible = obj && obj.mandatoryforEmployer != 2;
        }
        if (element.path === '/home/Bank-Details') {
          this.menuItems[index].visible = obj && obj.mandatoryforBankDetails != 2;
        }
        if (element.path === '/home/References') {
          this.menuItems[index].visible = obj && obj.mandatoryforReference != 2;
        }
        if (element.path === '/home/Onboarding-Declaration') {
          this.menuItems[index].visible = obj && obj.mandatoryforObDeclaration != 2;
        }

      }
    });
  }

  // private subscribeToEvents(): void {
  //   this.notification.messageReceived.subscribe((message: Message) => {
  //     this._ngZone.run(() => {
  //     });
  //   });
  // }

  /* fncssOptionsAccessRight(obj: any, getToken: any) {
    switch (obj.path) {
      case '/Timesheet-Submission':
        if (getToken[0].allowTimeSheetApply === 1) {
          return obj.type === getToken[0].isESS;
        }
        break;
      case '/Reimbursement-Claim':
        if (getToken[0].cssOptions.allowReimbApply === 1) {
          return obj.type === getToken[0].isESS;
        }
        break;
      case '/Apply-Leave':
        if (getToken[0].cssOptions.allowLeaveApply === 1) {
          return obj.type === getToken[0].isESS;
        }
        break;

    }
  } */
  updateDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'];
    this.menuMode = isLarge ? 'shrink' : 'overlap';
    this.menuRevealMode = isXSmall ? 'slide' : 'expand';
    this.minMenuSize = isXSmall ? 0 : 60;
    this.shaderEnabled = !isLarge;
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  navigationChanged(event) {
    const path = event.path;
    // const pointerEvent = event.event;
    if (path && this.menuOpened) {

      if (path == "/My-Details") {
        this.router.navigate(['/My-Details', btoa(JSON.stringify({ typeId: 0 })), 'Attendance']);
      } else if (path == "/HR-Activities") {
        const subPath = this.session[0].cssOptions.allowToResign === 1 ? '/Resignation' :
          this.session[0].cssOptions.allowLoanApply === 1 ? '/Loan-Request' :
            this.session[0].cssOptions.allowHRQuery === 1 ? '/My-Queries' :
              this.session[0].cssOptions.policyDocCnt > 0 ? '/Policy-Documents' :
                this.session[0].cssOptions.pFtrustDetailsCnt > 0 ? '/PF-Trust' :
                  this.session[0].cssOptions.genDeclarationCnt > 0 ? '/General-Declaration' :
                    this.session[0].cssOptions.insuranceCnt > 0 ? '/Insurance-Details' : '';

        this.router.navigate(['/HR-Activities' + subPath]);
      } else if (path == "/Financials") {
        this.router.navigate(['/Financials']);
      } else {
        this.router.navigate([path]);
      }


      if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.menuOpened = false;
        // pointerEvent.stopPropagation();
      }
    } else {
      // pointerEvent.preventDefault();
      if (path && !this.menuOpened) {

        if (path == "/My-Details") {
          this.router.navigate(['/My-Details', btoa(JSON.stringify({ typeId: 0 })), 'Attendance']);
        } else if (path == "/HR-Activities") {
          const subPath = this.session[0].cssOptions.allowToResign === 1 ? '/Resignation' :
            this.session[0].cssOptions.allowLoanApply === 1 ? '/Loan-Request' :
              this.session[0].cssOptions.allowHRQuery === 1 ? '/My-Queries' :
                this.session[0].cssOptions.policyDocCnt > 0 ? '/Policy-Documents' :
                  this.session[0].cssOptions.pFtrustDetailsCnt > 0 ? '/PF-Trust' :
                    this.session[0].cssOptions.genDeclarationCnt > 0 ? '/General-Declaration' :
                      this.session[0].cssOptions.insuranceCnt > 0 ? '/Insurance-Details' : '';
          this.router.navigate(['/HR-Activities' + subPath]);
        } else {
          this.router.navigate([path]);
        }


        if (this.hideMenuAfterNavigation) {
          this.temporaryMenuOpened = false;
          this.menuOpened = false;
          // pointerEvent.stopPropagation();
        }
      }
    }
  }
  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      // this.menuOpened = true;
    }
  }
  fnToggale() {
    this.menuOpened = !this.menuOpened;
    this.cookies.set('cssMenu', JSON.stringify(this.menuOpened));
  }

  fnSwitch() {
    localStorage.setItem('NEWUI', 'NEWUI');
    sessionStorage.setItem(this.enc.encryptUsingAES256('esstoken'), sessionStorage.getItem(this.enc.encryptUsingAES256('esstoken')));
    if (this.session[0].restrictEmpLogin) {
      window.open(APIConfing.data.apiConfing.newuiURL + (this.session[0].isESS === 'ESS' ? '/Offer-Acceptance' : '/home'), '_self');
    } else {
      window.open(APIConfing.data.apiConfing.newuiURL + (this.session[0].isESS === 'ESS' ? '/ESS-Home' : '/home'), '_self');
    }
  }

  toggle() {
    const getcss = document.getElementById('main-section');
    // console.log(getcss);

    if (getcss) {
      getcss.classList.toggle('newui');
    }
  }
}

@NgModule({
  imports: [SideNavigationMenuModule, DxDrawerModule, DxDataGridModule, HeaderModule, DxScrollViewModule, CommonModule, FooterModule, SignInModule],
  exports: [SideNavOuterToolbarComponent],
  declarations: [SideNavOuterToolbarComponent]
})
export class SideNavOuterToolbarModule { }
